import React, { Component } from 'react'
import { createPortal } from 'react-dom'

export class Portal extends Component {
  render() {
    const { children } = this.props;
    return createPortal(<>{children}</>, document.body);
  }
}
